import { createMuiTheme } from "@material-ui/core/styles";
import { Shadows } from "@material-ui/core/styles/shadows";
import { Colors } from "./colors";
import { Montserrat, MontserratBold, MontserratSemiBold } from "./fonts";

const defaultTheme = createMuiTheme();

const shadows = ["none", "0px 2px 6px #0000000A"];

const theme = createMuiTheme({
  mixins: {
    drawer: {
      width: 260,
      mobileBreakpoint: "md",
    },
    toolbar: {
      ...defaultTheme.mixins.toolbar,
      [defaultTheme.breakpoints.up("sm")]: {
        minHeight: 70,
      },
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [Montserrat, MontserratBold, MontserratSemiBold],
      },
    },
  },
  palette: {
    action: {
      hoverDark: Colors.DARK_HOVER,
    },
    primary: {
      main: Colors.DEFAULT,
      dark: Colors.DEFAULT_DARK,
      light: Colors.WHITE,
    },
    background: {
      default: Colors.BACKGROUND,
    },
  },
  shadows: defaultTheme.shadows.map((s, i) => shadows[i] || s) as Shadows,
  typography: {
    h1: {
      fontSize: 26,
    },
    h2: {
      fontSize: 22,
    },
    h3: { fontSize: 20 },
    h4: { fontSize: 18 },
    h5: { fontSize: 16 },
    h6: { fontSize: 14 },
    subtitle1: { fontSize: 20 },
    subtitle2: { fontSize: 18 },
    body1: { fontSize: 18 },
    body2: { fontSize: 16 },
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    button: {
      fontSize: defaultTheme.typography.pxToRem(18),
      fontWeight: 400,
    },
  },
});

console.log(theme);

export default theme;
